import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useSearchInputRedesignExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.SearchInputRedesignExperiment,
        AmplitudeVariants.SearchInputRedesignExperiment.Treatment
    );
